import React, { createContext, useContext, useMemo, useState, useCallback, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children, defaultLang = "en" }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return defaultLang;
    const stored = window.localStorage.getItem("ms-lang");
    return stored && translations[stored] ? stored : defaultLang;
  });

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    setLangState(code);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("ms-lang", code);
      document.documentElement.lang = code;
    }
  }, []);

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const value = useMemo(() => {
    const t = translations[lang];
    return { lang, setLang, t };
  }, [lang, setLang]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
